module.exports = __webpack_public_path__ + "static/media/next.e4f85fd6.svg";